export default "__VITE_ASSET__DzatJxqL__"